export const ADD_API_CONFIGURATION= "ADD_API_CONFIGURATION"
export const GET_API_CONFIGURATION = "GET_API_CONFIGURATION"
export const ALL_API_CONFIGURATION = "ALL_API_CONFIGURATION"
export const EDIT_API_CONFIGURATION = "EDIT_API_CONFIGURATION"